import React, { Suspense } from'react';
import vila_contabil_logo from'../assets/images/vila_contabil_logo.png';

interface ErrorBoundaryState { error: Error | null }

class RouteErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="vh-100 d-flex flex-column align-items-center justify-content-center text-center px-3">
          <i className="fa-solid fa-circle-exclamation fs-1 text-danger mb-3" />
          <h5 className="text-danger">Erro ao carregar a página</h5>
          <p className="text-muted small">{this.state.error.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export const LoadComponent = ({
  component: Component,
}: {
  component: React.LazyExoticComponent<React.ComponentType<any>>;
}) => {
  const loading = () => (
    <div className="vh-100 d-flex flex-column align-items-center justify-content-center">
      <img
        src={vila_contabil_logo}
        alt="Logo Vila Contábil"
        id="logo_loading"
        style={{ maxHeight:'100px' }}
      />
      <span className="mt-2">Carregando…</span>
    </div>
  );

  return (
    <RouteErrorBoundary>
      <Suspense fallback={loading()}>
        <Component />
      </Suspense>
    </RouteErrorBoundary>
  );
};

export type { RouteObject } from'./types';
